<template>
	<div class="flow-slideout">
		<div class="slideout-header">
			<!-- @slot Used to display slideout header -->
			<slot name="header" />
		</div>
		<div class="slideout-body">
			<!-- @slot Used to display slideout content -->
			<slot />
		</div>
		<div v-if="$slots.footer" class="slideout-footer">
			<!-- @slot Used to display optional slideout footer. -->
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * Slideout will have header,content and footer.
 */
export default defineComponent({
	name: "Slideout"
});
</script>
<style lang="scss">
$leave-duration: 0.4s;
$enter-duration: 0.4s;
.slideout-enter-active {
	animation: slideOut $enter-duration;
}

.slideout-leave-active {
	animation: slideIn $leave-duration;
}
div.flow-slideout {
	height: 100%;
	flex-direction: column;
	width: 100%;
	position: absolute;
	top: 0;
	display: flex;

	> div.slideout-header {
		display: flex;
		border-bottom: 1px solid var(--slideout-border-light);
		color: var(--slideout-font-dark);
		font-weight: 500;
		max-height: 52px;
		> div.slab-hierarchy > div.slab-container {
			background: inherit !important;
			height: 52px;

			&[selected]:not([disabled]),
			&:active:not([disabled]) {
				background-color: transparent !important;
			}
		}
		// .slideout-action {
		// 	flex: 0 0 48px;
		// 	justify-content: center;
		// 	align-items: center;
		// 	display: flex;
		// 	font-size: 16px;
		// 	height: 48px;
		// 	cursor: pointer;
		// 	svg {
		// 		stroke-width: 8px;
		// 	}
		// }
		// .slideout-title {
		// 	font-size: 16px;
		// 	// padding-top: 16px;
		// 	// padding-bottom: 16px;
		// 	line-height: 16px;
		// 	align-items: flex-start;
		// 	display: flex;
		// 	color: var(--slideout-font);
		// 	width: 100%;
		// }
	}

	> div.slideout-footer {
		// min-height: 48px;
		color: var(--slideout-font);
		border-top: 1px solid var(--slideout-border-light);
		color: var(--slideout-font-dark);
		font-size: 16px;
		line-height: 16px;
		justify-content: center;
		align-items: center;
		display: flex;
	}

	> div.slideout-body {
		height: 100%;
		overflow-y: auto;
		display: flex;
		position: relative;
		overflow-x: hidden;
		.slab-container[effects]:not([disabled]):hover .flow-picto-container {
			filter: contrast(85%);
		}
	}
}

@keyframes slideIn {
	0% {
		right: 0;
	}
	100% {
		right: -100%;
	}
}

@keyframes slideOut {
	0% {
		right: -100%;
	}
	100% {
		right: 0;
	}
}
</style>
